import { Spinner } from "@/components/ui/spinner";
import { Progress } from "@/components/ui/progress";
import type { ProgressLine } from "@/types";

export interface MapLoadingOverlayProps {
  loading: boolean;
  progress: ProgressLine | null;
}

/** Spinner + progress bar + "Loaded N of M" — the fleet-wide data-fetch
 *  loading pattern, replacing main.ts's showMapLoading()/setProgress(). */
export function MapLoadingOverlay({ loading, progress }: MapLoadingOverlayProps) {
  if (!loading) return null;
  return (
    <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 bg-background/70 backdrop-blur-sm">
      <Spinner className="size-6" />
      {progress &&
        (progress.total ? (
          <div className="w-56">
            <Progress value={Math.min(100, (progress.loaded / progress.total) * 100)} />
            <p className="mt-1.5 text-center text-xs text-muted-foreground">
              Snapping route legs {progress.loaded.toLocaleString()} of {progress.total.toLocaleString()}
            </p>
          </div>
        ) : (
          <p className="text-xs text-muted-foreground">Loaded {progress.loaded.toLocaleString()}…</p>
        ))}
    </div>
  );
}
